module.exports = __webpack_public_path__ + "img/gd_icon.0a41c635.png";